import { render, staticRenderFns } from "./subMenuCulture.vue?vue&type=template&id=b3d66bda&"
import script from "./subMenuCulture.vue?vue&type=script&lang=js&"
export * from "./subMenuCulture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports